<template>
  <section class="protfolio_list">
    <div class="container">
      <div class="row">
        <div class="tools_name col-sm-12 mb-3">
          <ul class="list-group d-block text-start gap-2">
            <li class="list-group-item border-0 d-inline">
              <button
                type="button"
                :class="
                  [toolsname == null ? 'active' : ''] +
                  ' btn btn-outline-secondary btn-sm mb-3'
                "
                @click="Imagefilter(null)"
              >
                All
              </button>
            </li>
            <li
              v-for="toolname in Toolname"
              :key="toolname.id"
              class="list-group-item border-0 d-inline"
            >
              <button
                type="button"
                :class="
                  [toolname == toolsname ? 'active' : ''] +
                  ' btn btn-outline-secondary btn-sm mb-3'
                "
                @click="Imagefilter(toolname)"
              >
                {{ toolname }}
              </button>
            </li>
          </ul>
        </div>

        <div
          class="col-sm-3 mb-4 position-relative"
          v-for="appimages in Filter_image"
          :key="appimages.id"
        >
          <img
            class="btn btn-primary w-100 p-0 border-0 mb-2"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            @click="popupp(appimages)"
            :src="require(`@/assets/images/${appimages.url}`)"
          />
          <span class="sub_tile">{{ appimages.title }}</span>
        </div>
      </div>
    </div>
  </section>
  <ModelPopup
    :img_name="imgname"
    :img_url="imgurl"
    :tools_name="ptoolsname"
    :view_url="visit_url"
  ></ModelPopup>
</template>

<script>
import ModelPopup from "@/components/ModelPopup.vue";

export default {
  name: "filter-image",
  components: {
    ModelPopup,
  },
  props: {
    arrydata: Object,
  },
  data() {
    return {
      imgname: "name",
      imgurl: "#",
      ptoolsname: "#",
      visit_url: "null",
      app_image: this.arrydata,
      toolsname: null,
    };
  },
  methods: {
    popupp(imagarr) {
      this.imgname = imagarr.name;
      this.imgurl = require(`@/assets/images/${imagarr.url}`);
      this.ptoolsname = imagarr.tools;
      this.visit_url = imagarr.viste_url;
    },
    Imagefilter(tools_name) {
      this.toolsname = tools_name;
    },
  },
  computed: {
    Toolname() {
      let arry = this.app_image;
      return [...new Set(arry.map((a) => a.tools))];
    },
    Filter_image() {
      let filter_data = "";
      if (this.toolsname == null) {
        filter_data = this.app_image;
      } else {
        let cfiltername = this.toolsname;
        var newarry = this.app_image.filter(
          (item) => item.tools == cfiltername
        );
        filter_data = newarry;
      }

      return filter_data;
    },
  },
};
</script>

<style>
</style>